// extracted by mini-css-extract-plugin
export default {"variantsContainer":"QuestionImgQuiz_variantsContainer__TPIT+","blockImgQuestion":"QuestionImgQuiz_blockImgQuestion__cfMd6","variants":"QuestionImgQuiz_variants__pLx4V"};